import React from 'react';
import PropTypes from 'prop-types';

import {Accordion, Icon, Message} from 'semantic-ui-react';
import {isNoU} from "utils/DBUtils";
import {scrollListener} from "hoc/ScrollListenerAccordion";

const BasicAccordion = (props) => {
    let primaryClass = "accordion-wrapper";
    if (props.active) {
        primaryClass += " active";
    }

  let classes = props.className ? primaryClass + " " + props.className : primaryClass;
  let animate = isNoU(props.animate) || props.animate === true;

    return (
        <div id={props.id} className={classes}>
            <Accordion fluid styled className={`db-edit-section active-accordion ${props.validationStatus}`}>
                <Accordion.Title index={props.index} onClick={props.onClick ? props.onClick : () => (undefined)}>
                    <Message info>
                        <Message.Header>
                            <span>{props.headerIcon || ""}{props.header  ? (typeof(props.header) === 'string' ? <span dangerouslySetInnerHTML={{__html: props.header}}></span> : props.header) : ""}</span>
                            {props.active ? <Icon name="minus"/> : <Icon name="plus"/>}
                        </Message.Header>
                    </Message>
                </Accordion.Title>
                <Accordion.Content active={props.active}>
                    {props.active ? props.children : []}
                </Accordion.Content>
            </Accordion>
        </div>
    )
};

BasicAccordion.propTypes = {
    header: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.node.isRequired
    ]),
    index: PropTypes.number.isRequired,
    active: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    headerIcon: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string
    ]),
    animate: PropTypes.bool,
    validationStatus: PropTypes.oneOf(["active", "error", "inactive", "success", "warning"])
};

BasicAccordion.defaultProps = {
    validationStatus: "active"
};

// Put scrolling listening here because its where the DOM element is created
// but after implementing thinking it would be better higher up in the hierarchy
// possible up to ResourceAccordion, maybe even a listener at the root
export default scrollListener(BasicAccordion);



// WEBPACK FOOTER //
// ./public/components/common/BasicAccordion.jsx